import { useEffect } from 'react';
import { useSelector, useDispatch  } from 'react-redux'
import { fetchTasks, setOwnerFilter } from '../../store/slices/tasksReducer'
import { getDomains } from '../../store/slices/domainsReducer'
import TaskPagination from './TaskPagination'
import TaskFilter from './TaskFilter'
import TaskListItem from './TaskListItem'
import Tabs from './Tabs'
import Map from './Map'

import '../../styles/home.scss';

const Home = (prop) => {
  const dispatch = useDispatch()
  const { data, loading, page, pageSize, search, ownerFilter } = useSelector(state => state.tasks)
  const { user } = useSelector(state => state.user);
  const viewMode = useSelector(state => state.viewMode);

  useEffect(() => {
    dispatch(getDomains());
    const req = dispatch(fetchTasks())
    return () => {
      req.abort();
    };
  }, [
    // Remove page and pageSize from dependencies since we fetch all tasks and paginate client-side
    dispatch,
    ownerFilter,
    viewMode.name,
    search
  ]);

  return <>
    <div className="u-bg-light">
      <Tabs />
    </div>
    <div className="u-container u-margin-top-xx u-margin-bottom-lg" role="main">
      <div className="row">
        <div className="col-xs-12 u-margin-top">
          <TaskFilter />
          { viewMode.name === "list" && <>
              <div className="u-margin-top">
                { loading === "loading" ? <div className="a-spinner" role="alert">
                  <span className="a-spinner__circle"></span>
                  <span className="a-spinner__text">Fetching data...</span>
                </div> : data.map((task) => <TaskListItem key={task.id} task={task} user={user} filter={ownerFilter}/>) }
              </div>
            { loading !== "loading" && data.length === 0  && <div className="dashed">
                { ownerFilter === 'mijntaken' &&  <p>Er zijn nog geen taken aan jou toegekend. Kies <span className="a" onClick={() => dispatch(setOwnerFilter('niettoegekend'))}>hier</span> een taak...</p> }
                { ownerFilter !== 'mijntaken' && <p>Er zijn geen taken gevonden </p>}
            </div> }
            <TaskPagination />
          </> }
          { viewMode.name === "map" && <Map /> }
        </div>
      </div>
    </div>
  </>
}

export default Home;
